export default __webpack_public_path__ + "static/media/Malaki_Portfolio5.99b9bf32.jpg";